module.exports = __webpack_public_path__ + "static/media/biteship-via-api.da8ddbe0.png";